<template>
  <div>
    <div>
      <div class="form-group">
        <b>Identificatorul tipului de achiziție</b>
        <v-select
          v-model="configs.identifier"
          :options="assignmentType"
          :disabled="initial ? true : false"
        />
      </div>
      <div v-if="configs.identifier" class="form-group">
        <div v-for="(item, index) of configs.config" :key="index">
          <div style="display: flex; align-items: center; margin-bottom: 8px">
            <input
              style="margin-right: 5px"
              type="text"
              class="vInput"
              v-model="item[0]"
            />
            <input
              style="margin-right: 5px"
              type="text"
              class="vInput"
              v-model="item[1]"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AssignmentDocumentType } from "@/common/types/command.type.js";

const DEFAULT_ASSIGNMENT_DOCUMENTS = {
  [AssignmentDocumentType.ComandaFermaTip1]: {
    termen_funizare_nevoie: "",
    articol_lege_procedura_achizitie: "",
    articol_lege_justificare_1: "",
    articol_lege_justificare_2: "",
  },
  [AssignmentDocumentType.ComandaFermaTip2]: {
    termen_funizare_nevoie: "",
    termen_plata_nevoie: "",
    articol_lege_procedura_achizitie: "",
    articol_lege_justificare: "",
  },
  [AssignmentDocumentType.ComandaFermaTip3]: {
    termen_funizare_nevoie: "",
    termen_plata_nevoie: "",
    articol_lege_procedura_achizitie: "",
    articol_lege_justificare_1: "",
    articol_lege_justificare_2: "",
  },
  [AssignmentDocumentType.ComandaFermaTip4]: {
    termen_funizare_nevoie: "",
    termen_plata_nevoie: "",
    articol_lege_procedura_achizitie: "",
    articol_lege_justificare: "",
  },
  [AssignmentDocumentType.ComandaFermaTipSocial]: {
    termen_funizare_nevoie: "",
    termen_plata_nevoie: "",
    articol_lege_procedura_achizitie: "",
    articol_lege_justificare: "",
  },
  [AssignmentDocumentType.ComandaFermaArt31]: {
    termen_funizare_nevoie: "",
    termen_plata_nevoie: "",
    articol_lege_procedura_achizitie: "",
    articol_lege_justificare: "",
  },
  [AssignmentDocumentType.ContractTip2]: {
    articol_lege_procedura_achizitie: "",
    articol_lege_justificare: "",
  },
  [AssignmentDocumentType.ContractTip3]: {
    articol_lege_procedura_achizitie: "",
    articol_lege_justificare_1: "",
    articol_lege_justificare_2: "",
  },
  [AssignmentDocumentType.ContractTip4]: {
    articol_lege_procedura_achizitie: "",
    articol_lege_justificare: "",
  },
  [AssignmentDocumentType.ContractTipSocial]: {
    articol_lege_procedura_achizitie: "",
    articol_lege_justificare: "",
  },
  [AssignmentDocumentType.ContractArt31]: {
    articol_lege_procedura_achizitie: "",
    articol_lege_justificare: "",
  },
  "verbal-process": {
    articol_lege_comisie_evaluare: "",
  },
  announcement: { termen_comercial: "", plata_achizitiei: "" },
};
export default {
  props: {
    initial: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      assignmentType: [
        ...Object.values(AssignmentDocumentType),
        "verbal-process",
        "announcement",
      ],
      configs: {
        identifier: "",
        config: [],
      },
    };
  },

  watch: {
    configs: {
      handler(value) {
        const _config = value.config.reduce((acc, item) => {
          acc[item[0]] = item[1];
          return acc;
        }, {});

        this.$emit("input", {
          identifier: value.identifier,
          config: _config,
        });
      },
      deep: true,
    },

    "configs.identifier": {
      handler(value) {
        this.initData();
      },
      immediate: true,
    },
  },

  methods: {
    // addConfig() {
    //   this.configs.config.push(["", ""]);
    // },
    // deleteConfig(index) {
    //   this.configs.config.splice(index, 1);
    // },

    initData() {
      let _config = {};

      if (this.configs.identifier) {
        _config = DEFAULT_ASSIGNMENT_DOCUMENTS[this.configs.identifier];
      }

      if (this.initial) {
        this.configs.identifier = this.initial.identifier;

        _config = DEFAULT_ASSIGNMENT_DOCUMENTS[this.initial.identifier];

        for (const key in this.initial.config) {
          _config[key] = this.initial.config[key];
        }
      }

      this.configs.config = Object.entries(_config);
    },
  },

  created() {
    this.initData();
  },
};
</script>
